<div class="container" [attr.id]="'courses-section'" id="courses-section">
	<div class="content">
		<div class="flex row search-bar-container">
			<mat-icon class="explore-icon" svgIcon="search"></mat-icon>
			<h5 class="one-line">{{'landing-page.courses_explore' | translateWithKeys}}</h5>
		</div>
		<h3>{{'landing-page.courses_title' | translateWithKeys}}</h3>
		<p>{{'landing-page.courses_description' | translateWithKeys}}</p>
		<div class="categories-container mt-40">
			@if (categories?.length > 0) {
				@for (category of categories; track $index) {
					<div class="category-container">
						<app-store-card [category]="category" [cardType]="cardTypes.VERTICAL"
							[cardTypeOrientation]="cardTypes.VERTICAL" [action]="category.__categoryCardAction">
						</app-store-card>
					</div>
				}
			} @else if (showSkeleton) {
				<div class="flex row wrap">
					@for (item of [].constructor(10); track $index) {
						<ngx-skeleton-loader [theme]="skeletonStyle"></ngx-skeleton-loader>
					}
				</div>
			}
		</div>

	</div>
</div>